// Environment configuration to ensure consistent backend usage
export interface AmplifyConfig {
  aws_project_region: string;
  aws_appsync_graphqlEndpoint: string;
  aws_appsync_region: string;
  aws_appsync_authenticationType: string;
  aws_appsync_apiKey: string;
  aws_user_files_s3_bucket: string;
  aws_user_files_s3_bucket_region: string;
}

// Dev backend configuration (the one that works with data)
const DEV_BACKEND_CONFIG: AmplifyConfig = {
  aws_project_region: "us-east-2",
  aws_appsync_graphqlEndpoint:
    "https://xni4nimt2jhmllo5qm3dxgmz3q.appsync-api.us-east-2.amazonaws.com/graphql",
  aws_appsync_region: "us-east-2",
  aws_appsync_authenticationType: "API_KEY",
  aws_appsync_apiKey: "da2-5payg75bhnabnh5i6zcfqbzgam",
  aws_user_files_s3_bucket:
    "standardleagued7d822ca9db04dc6988d2f04e7394e762534f-dev",
  aws_user_files_s3_bucket_region: "us-east-2",
};

// Get the current environment
const getCurrentEnvironment = (): "development" | "production" => {
  return process.env.NODE_ENV === "production" ? "production" : "development";
};

// Always use dev backend for consistency
export const getAmplifyConfig = (): AmplifyConfig => {
  const env = getCurrentEnvironment();

  // For now, always use dev backend since it has the data
  // In the future, you could switch this logic if needed
  console.log(`🔧 Using dev backend for ${env} environment`);
  return DEV_BACKEND_CONFIG;
};

// Export the config for use in amplify.ts
export const amplifyConfig = getAmplifyConfig();
